exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-content-my[data-v-574b80b0]{\n    max-width: 900px;\n}\n.modal-2[data-v-574b80b0]{\n    z-index: 2;\n}\n", ""]);

// exports
